var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRadioSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_2606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 22C18.1895 22 22.6667 17.5228 22.6667 12C22.6667 6.47715 18.1895 2 12.6667 2C7.14384 2 2.66669 6.47715 2.66669 12C2.66669 17.5228 7.14384 22 12.6667 22Z",
    fill: "#008EA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2667 8L10.6667 15.5L7.16669 12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_2606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666687)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadioSelected);
export default __webpack_public_path__ + "static/media/icon_radio_selected.821d2fd99b54fbd913078645549cf03a.svg";
export { ForwardRef as ReactComponent };